import { APPLY_FILTERS, PAGE_UP, PAGE_DOWN, RESET_PAGINATION, SET_LAST_PAGE, UNSET_LAST_PAGE } from '../constants';

const initialState = {
  page: 1,
  last: false,
};

export default function page(state = initialState, action) {
  switch (action.type) {
    case PAGE_UP: {
      return {
        ...state,
        page: state.page + 1,
      };
    }
    case PAGE_DOWN: {
      return {
        ...state,
        page: state.page - 1 > 1 ? state.page - 1 : 1,
      };
    }
    case APPLY_FILTERS:
    case RESET_PAGINATION: {
      return {
        ...state,
        page: 1,
      };
    }
    case SET_LAST_PAGE:
      return {
        ...state,
        last: true,
      };
    case UNSET_LAST_PAGE:
      return {
        ...state,
        last: false,
      };
    default:
      return state;
  }
}
